import request from '@/utils/request'

export function getUserServer(data) { // 获取区服
  return request({
    url: 'mall.api.login/getServer',
    method: 'post',
    data,
  })
}

export function getUserRole(data) { // 获取角色
  return request({
    url: 'mall.api.login/getRole',
    method: 'post',
    data,
  })
}

export function getShopList(data) { // 获取商品列表
  return request({
    url: 'mall.api.member/getPointProducts',
    method: 'post',
    data,
  })
}

export function exchangeShops(data) { //兑换商品
  return request({
    url: 'mall.api.member/getPointProductsExchange',
    method: 'post',
    data,
  })
}

export function getExchangeHistory(data) { //获取兑换记录
  return request({
    url: 'mall.api.member/getPointProductsExchangeList',
    method: 'post',
    data,
  })
}

export function bindUserAddress(data) { // 周边商品绑定地址
  return request({
    url: '/mall.api.member/getPointProductsBindContacts',
    method: 'post',
    data,
  })
}